/**
 * Thin wrapper over @capacitor/haptics so UI code can fire a tactile tick
 * without importing the plugin (and its native-only failure modes) directly.
 *
 * On the web / in tests the Capacitor plugin throws or no-ops; we swallow that
 * so a haptic call is always safe to make. The import is dynamic so the plugin
 * never loads in environments (jsdom test runner) that don't provide it.
 */

/** A light selection tick — used when the active Dex type changes on swipe. */
export async function hapticTick(): Promise<void> {
  try {
    const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    /* no native haptics (web/test) — silently ignore */
  }
}

/** A medium impact — used to confirm a long-press opened the hero panel. */
export async function hapticMedium(): Promise<void> {
  try {
    const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    /* no native haptics (web/test) — silently ignore */
  }
}
